import axios from 'axios';
import PropTypes from 'prop-types';

export default async function AxiosWrapper({
  isAuthRoute: isAuthRoute,
  ...options
}) {
  let _axiosOptions = options;
  if (isAuthRoute) {
    if (!_axiosOptions.headers) {
      _axiosOptions.headers = {};
    }
    _axiosOptions.headers.Authorization = `Basic ${window.localStorage.getItem(
      'token'
    )}`;
  }

  try {
    let res = await axios(_axiosOptions);
    return res;
  } catch (error) {
    if (error.response) {
      // Server responded with a status code outside the 2xx range
      console.error("Server Error:", error.response.data);
      return error.response;
    } else if (error.request) {
      // No response received from the server
      console.error("No response received:", error.request);
      throw new Error("No response from server.");
    } else {
      // Error setting up the request
      console.error("Error in request setup:", error.message);
      throw new Error(error.message);
    }
  }
}

export function AxiosAbort () {
  const axiosController = new AbortController();
  axiosController.abort();
}

AxiosWrapper.propTypes = {
  options: PropTypes.object.isRequired,
  isAuthRoute: PropTypes.bool
};

AxiosWrapper.defaultProps = {
  isAuthRoute: false
};
